// export const SIDEBAR_WIDTH = 96 // 左侧边栏宽度
export const SIDEBAR_WIDTH = 0 // 左侧边栏宽度 (已隐藏)
export const INDEX_CONTENT_LIST_WIDTH = 260 // index列表宽度
export const PAGINATION_HEIGHT = 60 // index底部分页高度

export const TOPBAR_HEIGHT = 50 // 顶部栏高度